import * as Redux from 'redux';
import {
  initialEmailTemplateState,
  GET_EMAIL_TEMPLATES,
  GET_EMAIL_TEMPLATES_PENDING,
  GET_EMAIL_TEMPLATES_FULFILLED,
  GET_EMAIL_TEMPLATES_REJECTED,
  CREATE_EMAIL_TEMPLATE,
  CREATE_EMAIL_TEMPLATE_PENDING,
  CREATE_EMAIL_TEMPLATE_FULFILLED,
  CREATE_EMAIL_TEMPLATE_REJECTED,
  UPDATE_EMAIL_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE_PENDING,
  UPDATE_EMAIL_TEMPLATE_FULFILLED,
  UPDATE_EMAIL_TEMPLATE_REJECTED,
  DELETE_EMAIL_TEMPLATE,
  DELETE_EMAIL_TEMPLATE_PENDING,
  DELETE_EMAIL_TEMPLATE_FULFILLED,
  DELETE_EMAIL_TEMPLATE_REJECTED,
  initialEmailResultState,
  GET_EMAIL_RESULTS_FULFILLED
} from './Constants';
import { SimpleResponse, ReduxAction } from 'src/app/app.types';
import { EmailTemplateState, EmailTemplateActionTypes, EmailTemplatesEntity, 
  EmailTemplate, EmailResultState, EmailResultEntity } from './Types';

function replaceUpdatedEmailTemplate(emailTemplates: EmailTemplate[],
  replaced: EmailTemplate | null): EmailTemplate[] {
  if (replaced) {
    return [replaced, ...emailTemplates.filter((emailTemplate) => {
      return replaced.id !== emailTemplate.id;
    })];
  } else {
    return emailTemplates;
  }
}

export const emailTemplateReducer: Redux.Reducer<EmailTemplateState> =
  (emailTemplateState: EmailTemplateState = initialEmailTemplateState,
    action: ReduxAction<EmailTemplateActionTypes, SimpleResponse<EmailTemplatesEntity>>):
    EmailTemplateState => {

    switch (action.type) {
      case CREATE_EMAIL_TEMPLATE_FULFILLED:
        return {
          ...emailTemplateState,
          statusCode: action.payload.statusCode,
          emailTemplates: [action.payload.body.entity, ...emailTemplateState.emailTemplates]
        };
      case GET_EMAIL_TEMPLATES_FULFILLED:
        return {
          ...emailTemplateState,
          statusCode: action.payload.statusCode,
          emailTemplates: action.payload.body.list
        };
      case UPDATE_EMAIL_TEMPLATE_FULFILLED:
        return {
          ...emailTemplateState,
          statusCode: action.payload.statusCode,
          emailTemplates: action.payload.body.entity ?
            replaceUpdatedEmailTemplate(emailTemplateState.emailTemplates,
              action.payload.body.entity) :
            [...emailTemplateState.emailTemplates]
        };
      case DELETE_EMAIL_TEMPLATE_FULFILLED:
        return {
          ...emailTemplateState,
          statusCode: action.payload.statusCode,
          emailTemplates: action.payload.body.list ?
            action.payload.body.list :
            emailTemplateState.emailTemplates
        };
      default:
        return {
          ...emailTemplateState
        };
    }
  };

  export const emailResultReducer: Redux.Reducer<EmailResultState> = 
  (emailResultState: EmailResultState = initialEmailResultState, 
    action: ReduxAction<EmailTemplateActionTypes, SimpleResponse<EmailResultEntity>>):
    EmailResultState => {
      switch (action.type) {
        case GET_EMAIL_RESULTS_FULFILLED:
          return {
            ...emailResultState,
            statusCode: action.payload.statusCode,
            emailResults : action.payload.body.list
          };
        default:
          return {
            ...emailResultState
          };
      }
    };



// WEBPACK FOOTER //
// ./src/emailTemplate/Reducer.tsx